var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import store from 'store';
import sizeStore from 'store/sizeStore';
import tag from 'core/tag';
import scroll from 'core/scroll';
import CustomPageManager from './CustomPageManager';
var MainPageManager = /** @class */ (function (_super) {
    __extends(MainPageManager, _super);
    function MainPageManager() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        Object.defineProperty(_this, "watchTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "io", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new IntersectionObserver(_this.onItemInView.bind(_this), { threshold: [0.5] })
        });
        Object.defineProperty(_this, "list", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(_this, "watch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.io.disconnect();
                var elementsToWatch = document.querySelectorAll(MainPageManager.itemsToWatch.join(','));
                elementsToWatch.forEach(function (el) { return _this.io.observe(el); });
            }
        });
        return _this;
    }
    Object.defineProperty(MainPageManager.prototype, "resetScroll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!document.scrollingElement)
                return;
            document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollTop, sizeStore.notificationHeight.get());
        }
    });
    Object.defineProperty(MainPageManager.prototype, "onItemInView", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (entries) {
            var _this = this;
            var lists = {};
            if (this.watchTimeout)
                clearTimeout(this.watchTimeout);
            this.watchTimeout = setTimeout(function () {
                var e_1, _a;
                try {
                    for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                        var entry = entries_1_1.value;
                        if (entry.isIntersecting) {
                            var el = entry.target;
                            var inDrawer = el.closest('.drawer');
                            if (inDrawer)
                                return;
                            var event = tag.getEvent(el);
                            if (event && event.ecommerce) {
                                if (lists[event.ecommerce.item_list_name])
                                    lists[event.ecommerce.item_list_name].push(event.ecommerce.items[0]);
                                else
                                    lists[event.ecommerce.item_list_name] = [event.ecommerce.items[0]];
                                _this.io.unobserve(el);
                                el.dataset.viewed = 'true';
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                tag.triggerListTag(lists);
            }, 200);
        }
    });
    Object.defineProperty(MainPageManager.prototype, "removePage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            if ((_a = this.currentPage) === null || _a === void 0 ? void 0 : _a.resetScroll)
                this.currentPage.resetScroll();
            else
                scroll.resetScroll();
            _super.prototype.removePage.call(this);
        }
    });
    Object.defineProperty(MainPageManager.prototype, "initializePage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, _super.prototype.initializePage.apply(this, __spreadArray([], __read(args), false))];
                        case 1:
                            _a.sent();
                            store.loading.set(false);
                            this.watch();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(MainPageManager.prototype, "extractPageInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (page) {
            return _super.prototype.extractPageInfo.call(this, page);
        }
    });
    Object.defineProperty(MainPageManager.prototype, "onRouteUpdate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var updated = _super.prototype.onRouteUpdate.apply(this, __spreadArray([], __read(args), false));
            if (updated !== true)
                return false;
        }
    });
    Object.defineProperty(MainPageManager.prototype, "cancelTransition", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            _super.prototype.cancelTransition.call(this);
            store.loading.set(false);
        }
    });
    Object.defineProperty(MainPageManager.prototype, "triggerInternalRouting", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _super.prototype.triggerInternalRouting.apply(this, __spreadArray([], __read(args), false));
            store.loading.set(false);
        }
    });
    Object.defineProperty(MainPageManager.prototype, "preloadPage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, _super.prototype.preloadPage.apply(this, __spreadArray([], __read(args), false))];
                        case 1:
                            _a.sent();
                            store.loading.set(false);
                            this.watch();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(MainPageManager.prototype, "createPage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _c, _d, _e;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_e = (_d = (_c = (_b = (_a = this.previousPage) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.currentPage) === null || _d === void 0 ? void 0 : _d.savePos) === null || _e === void 0 ? void 0 : _e.call(_d);
            return _super.prototype.createPage.apply(this, __spreadArray([], __read(args), false));
        }
    });
    Object.defineProperty(MainPageManager, "itemsToWatch", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: [' a.product-card[data-event]:not([data-viewed]), .row-product-card[data-event]:not([data-viewed]) ']
    });
    return MainPageManager;
}(CustomPageManager));
export default MainPageManager;
